import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { toastError, toastWarn } from "../../../common/Toast";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";

const SalesByCategories = (props) => {
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [supplierData, setSupplierData] = useState([]);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [salesTypeID, setSalesTypeID] = useState(0);
  const [saletype, setSaletype] = useState([]);
  const [employeeDropdown, setemployeeDropdown] = useState([]);
  const [tierid, settierid] = useState(0);
  const [supplierId, setSupplierId] = useState(0);
  const [employeeid, setemployeeid] = useState(0);
  const [topLevelCategory, setTopLevelCategory] = useState(false);
  const [totalData, setTotalData] = useState({
    TotalSum: 0,
    SubTotalSum: 0,
    TaxSum: 0,
    CostOfGoodsSoldSum: 0,
    ProfitSum: 0,
  });
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(locationid)
  );
  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (selectReport === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  let supplierOption = [];
  const Suppliers = supplierData.map((u, i) => {
    supplierOption[i] = {
      label: u.CompanyName + "(" + u.FirstName + " " + u.LastName + ")",
      value: u.ID,
    };
  });

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  const handleSupplierChange = (event) => {
    setSupplierId(event?.value);
  };

  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype
    .filter((u) => u.ID !== 3)
    .map((u, i) => {
      salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
    });

  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

  const apicall = () => {
    if (!topLevelCategory) {
      setLoading(true);
      setResponseData([]);
      axios
        .get(
          `${
            config.reportsBaseUrl
          }/reports/salesbycategories?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=0&startdate=${startdate}&enddate=${enddate}&tierid=${
            tierid ? tierid : 0
          }&employeeid=${employeeid ? employeeid : 0}&saletype=${
            salesTypeID ? salesTypeID : 0
          }&locationid=${selectedlocationid}&supplierid=${supplierId}&currentlocationid=${locationid}
        `,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            setResponseData(res.data.ResponseData);
            if (res.data.ResponseData.length > 0) {
              setTotalData({
                ...totalData,
                TotalSum: res.data.ResponseData[0].TotalSum,
                SubTotalSum: res.data.ResponseData[0].SubTotalSum,
                TaxSum: res.data.ResponseData[0].TaxSum,
                CostOfGoodsSoldSum: res.data.ResponseData[0].CostOfGoodsSoldSum,
                ProfitSum: res.data.ResponseData[0].ProfitSum,
              });
            } else {
              toastWarn("No Records Found!");
              setTotalData({
                ...totalData,
                TotalSum: 0,
                SubTotalSum: 0,
                TaxSum: 0,
                CostOfGoodsSoldSum: 0,
                ProfitSum: 0,
              });
            }
          }
          setLoading(false);
        })
        .catch((err) => {
          toastError("Something went wrong!");
          console.log(err);
          setLoading(false);
          return;
        });
    } else {
      setLoading(true);
      setResponseData([]);
      axios
        .get(
          `${
            config.reportsBaseUrl
          }/reports/showtoplevelcategory?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&tierid=${
            tierid ? tierid : 0
          }&employeeid=${employeeid ? employeeid : 0}&saletype=${
            salesTypeID ? salesTypeID : 0
          }&locationid=${selectedlocationid}&supplierid=${supplierId}&currentlocationid=${locationid}
        `,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            setResponseData(res.data.ResponseData);
            if (res.data.ResponseData.length > 0) {
              setTotalData({
                ...totalData,
                TotalSum: res.data.ResponseData[0].TotalSum,
                SubTotalSum: res.data.ResponseData[0].SubTotalSum,
                TaxSum: res.data.ResponseData[0].TaxSum,
                CostOfGoodsSoldSum: res.data.ResponseData[0].CostOfGoodsSoldSum,
                ProfitSum: res.data.ResponseData[0].ProfitSum,
              });
            } else {
              toastWarn("No Records Found!");
              setTotalData({
                ...totalData,
                TotalSum: 0,
                SubTotalSum: 0,
                TaxSum: 0,
                CostOfGoodsSoldSum: 0,
                ProfitSum: 0,
              });
            }
          }
          setLoading(false);
        })
        .catch((err) => {
          toastError("Something went wrong!");
          console.log(err);
          setLoading(false);
          return;
        });
    }
  };

  // useEffect(() => {
  //   const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
  //   const FilterColumnText = {};
  //   FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
  //     return { columnname: el.id, value: el.value, id: index + 1 };
  //   });

  //   let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  //   if (!topLevelCategory) {
  //     axios
  //       .get(
  //         `${
  //           config.reportsBaseUrl
  //         }/reports/salesbycategories?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
  //           sorting[0]?.desc === undefined
  //             ? "desc"
  //             : sorting[0]?.desc === true
  //             ? "desc"
  //             : "asc"
  //         }&ordercolumn=${columnIndex}&pagesize=${
  //           pagination.pageSize
  //         }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
  //           globalFilter === undefined ? "" : globalFilter
  //         }&startdate=${startdate}&enddate=${enddate}&tierid=${
  //           tierid ? tierid : 0
  //         }&employeeid=${employeeid ? employeeid : 0}&saletype=${
  //           salesTypeID ? salesTypeID : 0
  //         }&locationid=${locationid}
  //       `,
  //         {
  //           headers: {
  //             "Content-Type": "application/json;charset=UTF-8",
  //             "Access-Control-Allow-Origin": "*",
  //             Authorization: token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         console.log("res======>", res);
  //         console.log(res.data.ResponseData, "res======>");
  //         if (res.data.ResponseCode === "SUCCESS") {
  //           setResponseData(res.data.ResponseData);
  //           setData(res.data.ResponseData);
  //           if (res.data.ResponseData.length > 0) {
  //             setRowCount(res.data.ResponseData[0].TotalRecord);
  //             setTotalData({
  //               ...totalData,
  //               TotalSum: res.data.ResponseData[0].TotalSum,
  //               SubTotalSum: res.data.ResponseData[0].SubTotalSum,
  //               TaxSum: res.data.ResponseData[0].TaxSum,
  //               CostOfGoodsSoldSum: res.data.ResponseData[0].CostOfGoodsSoldSum,
  //               ProfitSum: res.data.ResponseData[0].ProfitSum,
  //             });
  //           } else {
  //             setRowCount(0);
  //             setTotalData({
  //               ...totalData,
  //               TotalSum: 0,
  //               SubTotalSum: 0,
  //               TaxSum: 0,
  //               CostOfGoodsSoldSum: 0,
  //               ProfitSum: 0,
  //             });
  //           }
  //         }
  //         setLoading(false);
  //       })
  //       .catch((err) => {
  //         setIsError(true);
  //         console.log(err);
  //         setLoading(false);
  //         return;
  //       });
  //   } else {
  //     axios
  //       .get(
  //         `${
  //           config.reportsBaseUrl
  //         }/reports/showtoplevelcategory?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
  //           sorting[0]?.desc === undefined
  //             ? "desc"
  //             : sorting[0]?.desc === true
  //             ? "desc"
  //             : "asc"
  //         }&ordercolumn=${columnIndex}&pagesize=${
  //           pagination.pageSize
  //         }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
  //           globalFilter === undefined ? "" : globalFilter
  //         }&startdate=${startdate}&enddate=${enddate}&tierid=${
  //           tierid ? tierid : 0
  //         }&employeeid=${employeeid ? employeeid : 0}&saletype=${
  //           salesTypeID ? salesTypeID : 0
  //         }&locationid=${locationid}
  //       `,
  //         {
  //           headers: {
  //             "Content-Type": "application/json;charset=UTF-8",
  //             "Access-Control-Allow-Origin": "*",
  //             Authorization: token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         console.log("res======>", res);
  //         console.log(res.data.ResponseData, "res======>");
  //         if (res.data.ResponseCode === "SUCCESS") {
  //           setResponseData(res.data.ResponseData);
  //           setData(res.data.ResponseData);
  //           if (res.data.ResponseData.length > 0) {
  //             setRowCount(res.data.ResponseData[0].TotalRecord);
  //             setTotalData({
  //               ...totalData,
  //               TotalSum: res.data.ResponseData[0].TotalSum,
  //               SubTotalSum: res.data.ResponseData[0].SubTotalSum,
  //               TaxSum: res.data.ResponseData[0].TaxSum,
  //               CostOfGoodsSoldSum: res.data.ResponseData[0].CostOfGoodsSoldSum,
  //               ProfitSum: res.data.ResponseData[0].ProfitSum,
  //             });
  //           } else {
  //             setRowCount(0);
  //             setTotalData({
  //               ...totalData,
  //               TotalSum: 0,
  //               SubTotalSum: 0,
  //               TaxSum: 0,
  //               CostOfGoodsSoldSum: 0,
  //               ProfitSum: 0,
  //             });
  //           }
  //         }
  //         setLoading(false);
  //       })
  //       .catch((err) => {
  //         setIsError(true);
  //         console.log(err);
  //         setLoading(false);
  //         return;
  //       });
  //   }
  //   setIsError(false);
  //   setIsLoading(false);
  //   setIsRefetching(false);
  // }, [
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  //   startdate,
  //   enddate,
  //   locationid,
  //   employeeid,
  //   tierid,
  //   salesTypeID,
  //   topLevelCategory,
  // ]);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    // axios
    //   .get(`${config.storeConfigBaseUrl}/storeconfig/Roletierdropdown`, {
    //     headers: {
    //       "Content-Type": "application/json;charset=UTF-8",
    //       "Access-Control-Allow-Origin": "*",
    //       Authorization: token,
    //     },
    //   })
    //   .then((response) => {
    //     setTierList(response.data?.ResponseData);
    //   })
    //   .catch((error) => {
    //     console.log(error.message);
    //   });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSupplierData(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${config.reportsBaseUrl}/reports/employeedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setemployeeDropdown(res.data.ResponseData);
        return res;
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload, enddate2);
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Category",
      accessorKey: "Category",
      filterFn: "contains",
    },
    {
      header: "Subtotal",
      accessorKey: "Subtotal",
      filterFn: "contains",
      Cell: ({ row }) => {
        const subtotal = row?.original?.Subtotal;
        if (subtotal == "0.00" || subtotal == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(subtotal),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Total",
      accessorKey: "Total",
      filterFn: "contains",
      // enableSorting: false,
      Cell: ({ row }) => {
        const total = row?.original?.Total;
        if (total == "0.00" || total == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(total),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Total Discounts",
      accessorKey: "TotalDiscount",
      filterFn: "contains",
      Cell: ({ row }) => {
        return (
          <div>
            {CurrencySymbols(
              Number(row.original.TotalDiscount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Quantity",
      accessorKey: "Quantity",
      filterFn: "contains",
    },
    {
      header: "Total Inventory Value",
      accessorKey: "TotalInventoryValue",
      filterFn: "contains",
      Cell: ({ row }) => {
        const totalInvValue = row?.original?.TotalInventoryValue;
        if (totalInvValue == "0.00" || totalInvValue == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(totalInvValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Total Inventory Value By Unit Price",
      accessorKey: "InventoryValueByUnitPrice",
      filterFn: "contains",
      Cell: ({ row }) => {
        const totalInvValueByPrice = row?.original?.InventoryValueByUnitPrice;
        if (totalInvValueByPrice == "0.00" || totalInvValueByPrice == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(totalInvValueByPrice),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Tax",
      accessorKey: "Tax",
      filterFn: "contains",
      Cell: ({ row }) => {
        return (
          <div>
            {CurrencySymbols(
              Number(row.original.TotalDiscount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Profit",
      accessorKey: "Profit",
      filterFn: "contains",
      Cell: ({ row }) => {
        const profit = row?.original?.Profit;
        if (profit == "0.00" || profit == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(profit),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Number Of Items Sold",
      accessorKey: "NumberOfitemsSold",
      filterFn: "contains",
    },
  ]);

  const handleChangeSalesType = (event) => {
    setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };

  const handleChangeEmployee = (event) => {
    setemployeeid(event?.value);
  };
  const handleChange = (event) => {
    setTopLevelCategory(event.target.checked);
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Sales By Categories</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report Period
              </label>
              <div className="row">
                <div className="col-md-12 z-5">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-3">Employee</label>
              <div className="row">
                <div className="col-md-12 z-6">
                  <Select
                    options={employeeDropdown.map((employee) => ({
                      label: employee.Name,
                      value: employee.Id,
                    }))}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(e, index) => handleChangeEmployee(e, index)}
                    className="custom-select-search"
                  />
                </div>
              </div>
            </div>

            <div className="col-sm-3 z-4">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Supplier
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    options={supplierOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(e) => handleSupplierChange(e)}
                    className="custom-select-search"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Sale Type
              </label>
              <div className="row">
                <div className="col-md-12 z-6">
                  <Select
                    defaultValue={salesTypeValue}
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-3 mt-5">
              <label className="col-form-label form-label p-lg-medium">
                <input
                  type="checkbox"
                  className="form-check-input mr-2"
                  style={{ width: "1.25em", height: "1.25em" }}
                  onChange={(e) => handleChange(e)}
                  //onInput={handleTopLevelCategory}
                  id="EntryCheck"
                  name="EntryCheck"
                  // disabled
                />
                Show Top Level Category Summary
              </label>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div
                className="row"
                style={{
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                }}
              >
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      {/* <p className="p-20">${totalData.SubTotalSum}</p> */}
                      <p className="p-20">
                        {CurrencySymbols(
                          Number(totalData.SubTotalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Subtotal</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      {/* <p className="p-20">${totalData.TotalSum}</p> */}
                      <p className="p-20">
                        {CurrencySymbols(
                          Number(totalData.TotalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      {/* <p className="p-20">${totalData.TaxSum}</p> */}
                      <p className="p-20">
                        {CurrencySymbols(
                          Number(totalData.TaxSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Tax</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      {/* <p className="p-20">${totalData.ProfitSum}</p> */}
                      <p className="p-20">
                        {CurrencySymbols(
                          Number(totalData.ProfitSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Profit</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">Sales By Categories</p>
                      <div className="row mb-2">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="table-responsive">
                    <div className="table mt-3"></div>
                    <div>
                      <CommonMatrialReactTable
                        MainHeading="Sonar POS"
                        ReportHeading="Sales By Categories"
                        columns={columns}
                        data={responseData}
                        startdate={startdate}
                        enddate={enddate}
                        columnGrouping={[]}
                        columnsVisibility={{}}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SalesByCategories;
